var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfFrame"},[_c('span',[_c('v-icon',{attrs:{"name":"spinner","spin":""}})],1),_c('span'),_c('span',[_vm._v("lade Rechnung")]),(_vm.pdf)?_c('div',[_c('iframe',{staticClass:"pdfFrame",attrs:{"src":_vm.pdf}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }